import { Component } from 'react';
import { shape, func } from 'prop-types';
import h from 'react-hyperscript';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';

import { getSelectedVenue, updateSelectedVenue } from '../../lib/venueSelector';

const sortByName = (a, b) => {
  const aName = a.name.toUpperCase();
  const bName = b.name.toUpperCase();

  if (aName < bName) {
    return -1;
  } else if (aName > bName) {
    return 1;
  }

  return 0;
};

class VenueSelector extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
  }

  componentWillReceiveProps(nextProps) {
    const { venue: { selected } = {} } = this.props;
    const { data: { loading, venues } } = nextProps;
    const { ...newProps } = nextProps;

    if (!loading) {
      if (venues && venues.length) {
        // Verify the last selected is valid still, then apply
        const lastVenue = getSelectedVenue();
        const foundMatch = lastVenue && venues.find(venue => venue.id === lastVenue.id);

        if (!foundMatch) {
          // Only these props are important to the UI
          const { id, name, configuration, compliance } = venues[0];
          const newSelectedVenue = {
            id,
            name,
            configuration,
            compliance,
          };

          updateSelectedVenue(newSelectedVenue);

          this.setSelectedVenue(newSelectedVenue);
        } else {
          // Only these props are important to the UI
          newProps.selectedVenue = {
            id: foundMatch.id,
            name: foundMatch.name,
            timezone: foundMatch.timezone,
            compliance: foundMatch.compliance,
            configuration: foundMatch.configuration,
          };

          updateSelectedVenue(newProps.selectedVenue);

          if (!selected) {
            this.setSelectedVenue(newProps.selectedVenue);
          }
        }
      } else {
        updateSelectedVenue(null);
      }
    }

    this.setState(newProps);
  }

  setSelectedVenue(venue) {
    const { venueSelected } = this.props;

    updateSelectedVenue(venue);

    // Dispatch action
    venueSelected({ venue });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  handleVenueSelected(venue) {
    this.setSelectedVenue(venue);
  }

  render() {
    const { data: { loading, venues = [] }, venue: { selected } = {} } = this.props;
    const { isOpen } = this.state;
    const href = 'javascript:;'; // eslint-disable-line no-script-url

    const showDropDown = !loading && venues && venues.length > 1;
    const showVenueOnly = !loading && venues && venues.length === 1;

    return h(
      'li.venue-selector.d-flex.justify-content-center.align-items-center',
      { className: showVenueOnly ? 'hidden-sm-down' : '' },
      [
        showDropDown &&
          h(Dropdown, { isOpen, toggle: () => this.toggle() }, [
            h(
              'a.nav-link.dropdown-toggle.nav-link.no-wrap.venue-selector-dropdown',
              {
                href,
                title: (selected && selected.name) || 'Select a Venue',
                onClick: () => this.toggle(),
                'data-toggle': 'dropdown',
                role: 'button',
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
              },
              [
                h('.text-ellipse.pull-left.venue-selector-selected', [
                  h('i.fa.fa-institution.mr-1'),
                  (selected && selected.name) || 'Select a Venue',
                ]),
              ],
            ),
            h(
              DropdownMenu,
              { className: 'dropdown-menu-right mr-1' },
              loading
                ? ''
                : Array.from(venues)
                    .sort(sortByName)
                    .map(({ id, name, ...rest }) =>
                      h(
                        DropdownItem,
                        {
                          className: 'venue-selector-item',
                          'data-id': id,
                          'data-name': name,
                          disabled: selected && id === selected.id,
                          onClick:
                            !selected || id !== selected.id
                              ? () => this.handleVenueSelected({ id, name, ...rest })
                              : () => {},
                        },
                        name,
                      ),
                    ),
            ),
          ]),
        showVenueOnly &&
          h(
            'a.nav-link.no-wrap.venue-selector-dropdown.text-muted',
            { title: (selected && selected.name) || 'Select a Venue' },
            [
              h('.text-ellipse.pull-left.venue-selector-selected', [
                h('i.fa.fa-institution.mr-1'),
                (selected && selected.name) || 'Select a Venue',
              ]),
            ],
          ),
      ],
    );
  }
}

VenueSelector.defaultProps = {
  data: {
    loading: true,
  },
  venue: {
    selected: {},
  },
};

VenueSelector.propTypes = {
  data: shape({}),
  venueSelected: func.isRequired,
  venue: shape({
    selected: shape({}),
  }),
};

export default VenueSelector;



// WEBPACK FOOTER //
// ./src/components/Venues/VenueSelector.js